module.exports = __webpack_public_path__ + "static/intro-07584f4be1813c733fa4dcc56717c20a.mp4";